var RATE_DECIMAL_PLACES = 7;
export function formatRateAndCurrency(_ref) {
  var rate = _ref.rate,
    currency = _ref.currency;
  return "".concat(currency, " ").concat(formatRate(rate));
}
function formatRate(rate) {
  return typeof rate === 'number' ? rate.toFixed(RATE_DECIMAL_PLACES) : rate;
}